
class VideoCarousel {
	constructor(){
		this.videocarousel = document.querySelector('.video-carousel');
		if (this.videocarousel) {
			this.videoCarouselElement =  this.videocarousel.querySelector(".video-carousel_thumbnails");
			if (this.videoCarouselElement){
				const numItems = this.videoCarouselElement.querySelectorAll('.thumbnails');
				this.initilizeCarousel(numItems,this.videoCarouselElement);
				// this.resizeCarousel(numItems,this.videoCarouselElement);
				window.addEventListener('resize', () => {		
					const numItems = this.videoCarouselElement.querySelectorAll('.thumbnails');
					const viewport = this.getCurrentViewport();
					const viewPortWidth = window.innerWidth;
					const element = this.videoCarouselElement;
			
					if (viewport === 'mobile' || viewport === 'tablet') {
						let carouselwidth = Math.ceil((.82 * viewPortWidth) * numItems.length);
						element.style.width = (carouselwidth + "px");
					} else if (viewport === 'desktop') {
						element.style.width = "144px";
					}
				});
			}
		}
	}

	initilizeCarousel(thumbnails, element){
		const viewport = this.getCurrentViewport();
		const numItems = thumbnails.length;
		const viewPortWidth = window.innerWidth;

		if (viewport === 'mobile' || viewport === 'tablet') {
			let carouselwidth = Math.ceil((.82 * viewPortWidth) * numItems);
			element.style.width = (carouselwidth + "px");
		}
	}

	
getCurrentViewport() {

	const viewport = window.innerWidth;

	if (viewport >= 0 && viewport < 768) {
		return 'mobile';
 
	} else if (viewport >= 768 && viewport <= 860) {
		return 'tablet';
 
	} else {
		return 'desktop';
 
	}
				 
 }


}
new VideoCarousel();

